















































import {
  Component, Vue, Model, Watch,
} from 'vue-property-decorator';

@Component
export default class FeatureEditor extends Vue {
  @Model('input', { type: [String] })
  readonly value!: string | null;

  localList: string[] = this.value ? this.value.split(',') : [''];

  @Watch('value')
  onValueChanged(newValue: string) {
    this.localList = newValue ? newValue.split(',') : [''];
  }

  @Watch('localList')
  onLocalListChanged() {
    this.$emit('input', this.localList.join(','));
  }

  newItme() {
    this.localList.push('');
  }

  removeItem(index: number) {
    this.localList.splice(index, 1);
  }
}
